"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var check = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

var before = function before() {};

var after = function after() {};

if (check) {
  before = function before() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    console.group('Context action:', action.type);
    console.log('State before action:', state);
    console.log('Full action:', action);
  };

  after = function after() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    console.log('State after action:', state);
    console.groupEnd();
  };
}

var _default = {
  before: before,
  after: after
};
exports.default = _default;